import type { BaseToolWire } from './baseToolSchema';

/**
 * What the base tool form starts from: the most typical tool of the ISO-13399 catalogue.
 *
 * Picked from the worker's data (`tool_recommender/data/ISO13399.xlsx`, 930 tools, 2026-09-18) as
 * the real tool closest to the catalogue's profile — median of every numeric field, most common
 * value of every choice: article `103-0d1.60` (reference 103-0), a Ø1.6 three-flute 30° end mill.
 * A real tool rather than 41 independent averages, so that the values are coherent together.
 *
 * Nine fields are empty on that tool, as on most of the catalogue (four of them on every tool):
 * `hélice 2`, the collet (D2, L2), `Largeur cassé de coupe`, `Largeur d'âme`, `Noyau arrière`,
 * `Creux 2`, `Creux 3`, `longueur creux`. The form requires a value, so they hold their range
 * **minimum**: that is what the model itself substitutes for an empty value
 * (`FillNaWithValue(min)` in `toolfinder_score_pred_feature_transformer.py`). With these values the
 * model input is identical to that of the catalogue tool — checked through the worker's own
 * feature transformer. `-90°` or `-0.5 mm` therefore mean "this tool has none", not a geometry.
 */
export const DEFAULT_BASE_TOOL: BaseToolWire = {
  d1: 1.6,
  l1: 3,
  'Longueur utile maximum LUX [mm]': 3.7,
  'diam. collet  #1 (D2)': 0,
  'long. collet #1 (L2)': 0,
  'Demi angle du cône du corps BHTA [°]': 13,
  'Rayon de rectifiage': 0,
  'Nb dents': 3,
  'hélice 1': 30,
  'hélice 2': -90,
  'Sens de coupe': 'D',
  Profil: 'Lisse',
  'Pas du profil': '-',
  'Forme de la fraise': 'Fermée',
  Coin: 'Vif',
  'Coupe au centre': 'Oui',
  'Cassé de coupe': 'NON',
  'Largeur cassé de coupe': 0.01,
  'Angle de coupe bout': 6,
  'Angle de coupe diamètre mini goujure 1': 8,
  'Angle de coupe diamètre maxi goujure 1': 10,
  '1ère dépouille bout': 10,
  '2ème dépouille bout': 30,
  '1ère dépouille diamètre': 10,
  'type de dépouille diamètre': 'Radiale',
  'Affûtage bout': 'Une dent au centre',
  'Largeur affûtage bout': 0.16,
  'Dépassement du centre': 0.02,
  'Largeur listel': 0.23,
  "Largeur d'âme": -0.5,
  'Noyau [mm]': 0.8,
  'Noyau arrière': 0,
  'Creux 1 [°]': 1,
  'Creux 2 [°]': -90,
  'Creux 3 [°]': -90,
  'longueur creux': 0,
  'Indexation taillage': 'Régulière',
  'Indexation taillage angle': '120',
  'Type de fabrication': 'Monobloc',
  'Substrat / matière outil': 'MD',
  '% de Co': 10,
};
